import React from "react";
import { Row, Col } from "../ui/ot";
import { PieChart, Pie, LabelList } from "recharts";
import {
    ChartContainer,
    ChartTooltip,
    ChartTooltipContent,
    ChartLegend,
    ChartLegendContent
} from "../ui/chart";

const PieDonutChart = ({
    chartConfig = {},
    chartData = [],
    xDataKeyArr = ["category"], // 顯示名稱
    yDataKeyArr = ["value"],    // 數值
    showLabel = true,
    labelType = "inner",        // "inner" | "outer" | "none"
    showLegend = true,
    legendLayout = "horizontal", // "horizontal" | "vertical"
    innerRadius = 0,            // > 0 => donut style
}) => {
    return (
        <Row>
            <Col span={24}>
                {xDataKeyArr.map((xDataKey) =>
                    yDataKeyArr.map((yDataKey) => {
                        const chartDataColor = chartData.map((value) => ({
                            ...value,
                            fill: `var(--color-${value[xDataKey]})`,
                        }));

                        return (
                            <ChartContainer
                                key={`${xDataKey}-${yDataKey}`}
                                config={chartConfig}
                                className="mx-auto aspect-square max-h-[300px]"
                            >
                                <PieChart>
                                    <ChartTooltip
                                        cursor={false}
                                        content={<ChartTooltipContent hideLabel />}
                                    />
                                    <Pie
                                        data={chartDataColor}
                                        dataKey={yDataKey}
                                        nameKey={xDataKey}
                                        innerRadius={innerRadius}
                                        // label={showLabel && labelType !== "none" ? ({
                                        //     cx, cy, midAngle, innerRadius, outerRadius, percent, index, payload
                                        // }) => {
                                        //     const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
                                        //     const RADIAN = Math.PI / 180;
                                        //     const x = cx + radius * Math.cos(-midAngle * RADIAN);
                                        //     const y = cy + radius * Math.sin(-midAngle * RADIAN);
                                        //     return (
                                        //         <text
                                        //             x={x}
                                        //             y={y}
                                        //             fill="black"
                                        //             textAnchor="middle"
                                        //             dominantBaseline="central"
                                        //             fontSize={12}
                                        //         >
                                        //             {`${chartConfig[payload[xDataKey]]?.label || payload[xDataKey]} (${payload[yDataKey]})`}
                                        //         </text>
                                        //     );
                                        // } : false}
                                    >
                                        {showLabel && labelType !== "none" && (
                                            <LabelList
                                                dataKey={xDataKey}
                                                position={labelType}
                                                formatter={(value) => chartConfig[value]?.label || value}
                                            />
                                        )}
                                    </Pie>
                                    {showLegend && (
                                        <ChartLegend
                                            content={<ChartLegendContent nameKey={xDataKey} />}
                                            layout={legendLayout}
                                            verticalAlign={legendLayout === "vertical" ? "middle" : "bottom"}
                                            align={legendLayout === "vertical" ? "right" : "center"}
                                            wrapperStyle={{
                                                display: "flex",
                                                flexWrap: "wrap",
                                                justifyContent: legendLayout === "horizontal" ? "center" : "flex-start",
                                                gap: "0.5rem"
                                            }}
                                        />
                                    )}
                                </PieChart>
                            </ChartContainer>
                        );
                    })
                )}
            </Col>
        </Row>
    );
};

export default PieDonutChart;
